import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from '../../utils/translate';

import './index.scss';

import * as compassBg from './static/img/compass__bg.svg';
import * as compassArrow from './static/img/compass__arrow.svg';
import * as arrowTop from './static/img/arrow_top.svg';

interface Props {
  hint?: boolean;
}

const b = b_.with('not-found-error');

class NotFound extends React.Component<Props & InjectedTranslateProps> {
  render() {
    const { t, hint } = this.props;

    return (
      <div className={b()}>
        <div className={b('icon')}>
          <img src={compassBg} className={b('icon_bg')} alt="" />
          <img src={compassArrow} className={b('icon_arrow')} alt="" />
        </div>
        <div className={b('reason')}>{t('Error 404')}</div>
        <div className={b('desc')}>{t('Oops Page not found')}</div>
        {hint && (
          <div className={b('arrow')}>
            <div>{t('Use menu')}</div>
            <img src={arrowTop} alt="" />
          </div>
        )}
      </div>
    );
  }
}

export default translate(NotFound);
